import CommentsInput from 'components/Comments/CommentsInput'
import { useOutletContext } from 'react-router-dom'

interface OrganizationContext {
  pinned: boolean
  expanded: boolean
  organization: any
}

const OrganizationComments = () => {
  const { expanded } = useOutletContext<OrganizationContext>()

  return (
    <CommentsInput
      taskSKs={[]}
      contextFilters={['organization']}
      expanded={expanded}
      context="organization"
      checklistItems={[]}
    />
  )
}

export default OrganizationComments
